window.onload = function() {
    // 首页初始化
    obj.init();
}

var config = { uid: 0, channel: null, life: 100 };

var bindParams = {};

var api = "//api.qingcigame.com";

var loginAPI = "//mapi.qingcigame.com"

var shareURL = "https://snail.qingcigame.com/christmas/"

var obj = {
    // 初始化
    init: function() {
        this.preloading(); // 预加载
        this.swiper(); // swiper轮播
        this.userInfo(); // 获取用户信息
        this.bind();
        this.preventInput(); // 阻止页
    },

    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
            // console.log(numbers);

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);

            // 漫画显示
            $('.cartoon-wrap').fadeIn();

            setTimeout(function() {
                $('.cartoon-1').fadeIn();
                $('.preloading').remove();
            }, 1000)
        }, this);

        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/snail/christmas/images/m_dt_sz-415c2bd1b7.png',
            '//static.qcplay.com/snail/christmas/images/m_dt_t-3c93eb7544.png',
            '//static.qcplay.com/snail/christmas/images/m_jdt-9a61456b4c.png',
            '//static.qcplay.com/snail/christmas/images/index_01_bg-7c90f2a0eb.jpg',
            '//static.qcplay.com/snail/christmas/images/index_01-e6a43af6f0.jpg',
            '//static.qcplay.com/snail/christmas/images/cartoon/1-bed6916731.png',
            '//static.qcplay.com/snail/christmas/images/cartoon/2-87dbb176d5.png',
            '//static.qcplay.com/snail/christmas/images/cartoon/3-db8497b0e8.png',
            '//static.qcplay.com/snail/christmas/images/cartoon/4-1880d81e57.png',
            '//static.qcplay.com/snail/christmas/images/arms/1-9a8a50b450.png',
            '//static.qcplay.com/snail/christmas/images/arms/2-f0d0e66460.png',
            '//static.qcplay.com/snail/christmas/images/arms/3-686c9d705f.png',
            '//static.qcplay.com/snail/christmas/images/arms/4-82f9e87d52.png',
            '//static.qcplay.com/snail/christmas/images/christmas_tree-7bff22c78a.png',
            '//static.qcplay.com/snail/christmas/images/title_banner-5f848e6410.png',
            '//static.qcplay.com/snail/christmas/images/title_banner_02-1152f28c6b.png',
            '//static.qcplay.com/snail/christmas/images/btn_00-af42f84c47.png',
            '//static.qcplay.com/snail/christmas/images/btn_00_02-5e18d92481.png',
        ]);

        var cartoonNum = 1;
        $('.cartoon-wrap').on('click', function(event) {
            cartoonNum++
            $('.cartoon-' + cartoonNum + '').fadeIn();
            if (cartoonNum >= 5) {
                $('.cartoon-wrap').addClass('preloading-ani').fadeOut(1000);
                $('.index').removeClass('landing');

                // 音乐播放
                $('#myMusic')[0].play();
                $('.music').addClass('on');
            }
        });
    },

    // 整屏切换
    swiper: function() {
        var swiperH = new Swiper('.swiper-container-h', {
            direction: 'vertical',
            pagination: '.swiper-pagination',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheelControl: true,
            resistanceRatio: 0,
            onInit: function(swiper) { //Swiper2.x的初始化是onFirstInit
                swiperAnimateCache(swiper); //隐藏动画元素 
                swiperAnimate(swiper); //初始化完成开始动画

            },
            onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
            },
            onTouchEnd: function(swiper) {
                swiperAnimate(swiper);
            },
        });

        function Ani(btn, page) {
            $(btn).on('click', function() {
                swiperH.slideTo(page, 1000, true);
            });
        };
        var aniLink01 = Ani('.act-btn', '1');
        var aniLink02 = Ani('.top-arrow', '0');

        var mySwiper2 = new Swiper('#swiper-container2', { //子swiper
            direction: 'vertical',
            nested: true,
            slidesPerView: 'auto',
            freeMode: true,
            resistanceRatio: 0,
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });
    },

    // 游戏帐号信息
    userInfo: function() {
        $.ajax({
            url: api + "/snail/christmas/userinfo",
            type: "GET",
            xhrFields: { withCredentials: true },
            error: function() {
                layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
            },
            success: function(json) {
                // 如果账号没登录，先跳转去登录
                if (json.code == 302) {
                    layer.load(1);
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        // 如果在微信里面
                        window.location.href = loginAPI + '/wechat/oauth/?callback=christmas';
                        return;
                    } else {
                        // 如果在QQ里面
                        window.location.href = api + '/qq/oauth/?callback=' + encodeURI(window.location.href);
                        return;
                    }
                }

                // 设置头像信息
                $('.account-info .pic img').attr('src', json.data.avatar);
                // 设置昵称
                if (json.data.role_name == null || json.data.role_name == "") {
                    $('.account-info .info .account').html('请登录');
                } else {
                    $('.account-info .info .account').html(json.data.role_name + '<br/>' + json.data.area_name + '&nbsp;' + json.data.server_id + '服');
                }
                // 设置绑定状态
                $('.account-info .tab-acco').removeClass('tab-change')
                if (json.data.channel) {
                    $('.account-info .tab-acco').addClass('tab-change');
                }

                // 助力人列表
                var $helperList = $('.helper-list');
                if (json.data.helper_list.length == 0) {
                    $helperList.addClass('list-ul-null');
                } else {
                    $helperList.removeClass('list-ul-null');
                }
                $helperList.html('');
                for (var key in json.data.helper_list) {
                    var value = json.data.helper_list[key];

                    var createdAt = value.created_at.split(' ');
                    var date = createdAt[0].split('-');
                    var time = createdAt[1].split(':');
                    var helpTime = date[1] + "/" + date[2] + " " + time[0] + ":" + time[1];

                    var $li = $('<li></li>');
                    $li.append('<img src="' + value.user_info.avatar + '">')
                    $li.append('<div><h3><span>' + value.user_info.nickname + '</span><span>' + helpTime + '</span></h3><p>投掷' + value.rank_name + '(-' + value.score + 'HP)</p></div>')

                    $helperList.append($li);
                }


                // 设置用户状态
                config.uid = json.data.uid;
                config.channel = json.data.channel;
                obj.effect(100 - json.data.score, json.data.count, json.data.help_count);

                // 分享设置
                obj.share();
            }
        })
    },

    // 进行
    login: function() {
        // 初始化打开状态
        $('.inp-account').val('');
        $('.inp-password').val('');
        $('.register-popup').fadeIn();
        openA();
        //  开启动画
        function openA() {
            setTimeout(function() {
                $('.popup_box').addClass('ani');
            }, 200);
        }
    },

    serverInfo: function() {
        // 初始化打开状态
        $('.tab-server').show();
        $('.tab-server').find('.active').removeClass('active');
        $('.tab-server').find('div:first').addClass('active');
        $('.gzf').addClass('show');
        $('.zsf').removeClass('show');
        $('input[name=gzf_role_name]').val('');
        $('input[name=zsf_role_name]').val('');

        // 初始化参数状态
        bindParams = {};

        var index = layer.load(1);
        $.ajax({
            url: api + '/snail/server/qcgame',
            type: "GET",
            xhrFields: { withCredentials: true },
            error: function() {
                layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
            },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return;
                }

                var gzf = json.data[26];
                var zsf = json.data[39];

                if (!gzf && !zsf) {
                    layer.msg("查无您的角色信息");
                    return;
                } else if (!gzf || !zsf) {
                    $('.tab-server').hide();
                } else {
                    $('.tab-server').show();
                }

                if (gzf) {
                    $('.gzf select').html('<option value="">请选择区组</option>');
                    var list = gzf.android;
                    for (var key in list) {
                        var value = list[key];
                        $('.gzf select').append('<option data-dist-number="' + value['dist_number'] + '" data-dist-name="' + value['dist_name'] + '" data-rid="' + value['rid'] + '" data-zone="' + value['zone'] + '" data-role-name="' + value['nickname'] + '">' + value['dist_number'] + '服-' + value['dist_name'] + '</option>')
                    }

                    $('.gzf select').off('change').on('change', function() {
                        var option = $(this).find('option:selected');
                        if (option.val()) {
                            // 改值
                            $('input[name=gzf_role_name]').val($(this).find('option:selected').attr('data-role-name'));
                            bindParams = {
                                game_id: 26,
                                server_name: option.attr('data-dist-number'),
                                role_name: option.attr('data-role-name'),
                                zone: option.attr('data-zone'),
                                rid: option.attr('data-rid'),
                                dist_name: option.attr('data-dist-name'),
                                dist_number: option.attr('data-dist-number'),
                                type: "android"
                            }
                        } else {
                            // 清空
                            $('input[name=gzf_role_name]').val('');
                            bindParams = {};
                        }

                    })

                } else {
                    $('.gzf').removeClass('show');
                }

                if (zsf) {
                    // 如果没有光子服就显示
                    gzf ? $('.zsf').removeClass('show') : $('.zsf').addClass('show');

                    // 初始化内容
                    $('.zsf-os').html('<option value="">请选择手机系统</option>')
                    $('.zsf-server').html('<option value="">请选择区服</option>')

                    // 拼接手机系统
                    for (var key in zsf) {
                        $('.zsf-os').append('<option value="' + key + '">' + key + '</option>')
                    }

                    // 手机系统选择
                    $('.zsf-os').off('change').on('change', function() {

                        bindParams = { game_id: 39, type: $(this).val() }

                        var role = zsf[$(this).val()];
                        // 区服下拉框设置为空
                        $('.zsf-server').html('<option value="">请选择区服</option>');
                        // 角色信息为空
                        $('.zsf-role').val('');
                        // 拼接区服下拉框
                        for (var key in role) {
                            var value = role[key];
                            $('.zsf-server').append('<option data-dist-number="' + value['dist_number'] + '" data-dist-name="' + value['dist_name'] + '" data-rid="' + value['rid'] + '" data-zone="' + value['zone'] + '" data-server-name="' + value['dist_name'] + '" data-role-name="' + value['nickname'] + '">' + value['dist_number'] + '服-' + value['dist_name'] + '</option>')
                        }

                        // 响应区服下拉框事件
                        $('.zsf-server').on('change', function() {
                            var option = $(this).find('option:selected');
                            if (option.val()) {
                                $('.zsf-role').val(option.attr('data-role-name'))
                                bindParams.server_name = option.attr('data-dist-number')
                                bindParams.role_name = option.attr('data-role-name')
                                bindParams.zone = option.attr('data-zone')
                                bindParams.rid = option.attr('data-rid')
                                bindParams.dist_name = option.attr('data-dist-name')
                                bindParams.dist_number = option.attr('data-dist-number')
                            } else {
                                $('.zsf-role').val('');
                                bindParams = { game_id: 39, type: $(this).val() }
                            }
                        });
                    })

                } else {
                    $('.zsf').removeClass('show');
                }


                $('.inp-account').val(''); // 账号密码清空
                $('.inp-password').val(''); // 账号密码清空
                $('.register-popup').fadeOut(); // 关闭登陆页面
                $('.server-popup').fadeIn(); // 开启服务器
                $('.popup_box').addClass('ani');
            },
            complete: function() {
                layer.close(index);
            }
        });
    },

    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href
            },
            success: function(json) {


                // 此刻分享的页面
                var today = new Date()
                var year = today.getFullYear();
                var month = today.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = today.getDate();
                day = day < 10 ? "0" + day : day;
                var hour = today.getHours();
                hour = hour < 10 ? "0" + hour : hour;
                var minute = today.getMinutes()
                minute = parseInt(minute / 10) * 10;
                minute = minute < 10 ? "00" : minute;
                var file = year + "" + month + "" + day + "" + hour + "" + minute;

                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        wx.updateAppMessageShareData({
                            title: '鹿见不平，雪战相助', // 分享标题
                            desc: '快来帮蜗扔雪球！', // 分享描述
                            link: shareURL + file + '.html?uid=' + config.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/share.jpg', // 分享图标
                            success: function() {}
                        })

                        wx.updateTimelineShareData({
                            title: '鹿见不平，雪战相助', // 分享标题
                            link: shareURL + file + '.html?uid=' + config.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/share.jpg', // 分享图标
                            success: function() {
                                // 设置成功
                            }
                        })
                    });
                    return;
                } else {
                    setShareInfo({
                        title: '鹿见不平，雪战相助', // 分享标题
                        summary: '快来帮蜗扔雪球！', // 分享内容
                        pic: 'https://static.qcplay.com/common/share.jpg', // 分享图片
                        url: shareURL + file + '.html?uid=' + config.uid, // 分享链接
                        // 微信权限验证配置信息，若不在微信传播，可忽略
                        WXconfig: {
                            appId: json.data.appId, // 公众号的唯一标识
                            timestamp: json.data.timestamp, // 生成签名的时间戳
                            nonceStr: json.data.nonceStr, // 生成签名的随机串
                            signature: json.data.signature // 签名
                        }
                    });
                }
            }
        })
    },

    bind: function() {

        // 埋点
        $('.ambush').click(function() {
            var data = $(this).attr('data');
            $.ajax({
                url: api + "/snail/christmas/count",
                type: "POST",
                xhrFields: { withCredentials: true },
                data: {
                    type: data
                },
                error: function() {},
                success: function(json) {
                    console.log('埋点:' + data);
                },
                complete: function() {
                    layer.close(index)
                }
            });
        });

        // tab切换（青瓷登录 or b站）
        $('.introduce-box .label-main').on('click', 'div', function(event) {
            $(this).addClass('select').siblings().removeClass('select').parent('.label-main').siblings().children('.int-box').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        // 点击分享
        $('.share-btn').on('click', function() {
            // 未登录先登录
            if (!config.channel) {
                obj.login();
                openA();
                return;
            }
            if (satisfy) {
                return;
            }
            // if (config.account == "") {
            //     obj.login();
            //     return;
            // }
            $('.share-popup').fadeIn();
            openA();
        });

        $('.register-box .title').on('click', 'div', function(event) {
            $(this).addClass('active').siblings().removeClass('active').parent('.title').siblings('.form-main').children('.form').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.register-tab-title').on('click', 'h2', function(event) {
            $(this).addClass('select').siblings().removeClass('select').parent('.register-tab-title').siblings('.register-tab-box').children('.register-box').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.tab-server').on('click', 'div', function(event) {
            $(this).addClass('active').siblings().removeClass('active').parent('.tab-server').siblings('.option-main').children('.option-box').eq($(this).index()).addClass('show').siblings().removeClass('show');

            $('.gzf select').val('')
            $('.gzf input[name=gzf_role_name]').val('')
            $('.zsf-os').val('')
            $('.zsf-server').val('')
            $('.zsf input[name=zsf_role_name]').val('');

            bindParams = {
                game_id: $(this).parent().find('.active').attr('data-game-id'),
                server_name: "",
                role_name: "",
                zone: "",
                rid: "",
                dist_name: "",
                dist_number: "",
                type: ""
            }
        });

        // b站游戏角色登录
        $('.binding-btn').click(function() {
            // CZ9SGDZDXRS360
            // 穿越者11262
            var roleName = $('.inp-role-name').val();
            var roleId = $('.inp-role-id').val();
            var channelName = $(".select-channel[name='channel_name']").val();
            console.log(channelName);

            if (roleName == "") {
                layer.msg("请输入角色名称");
                return
            }
            if (roleId == "") {
                layer.msg("请输入角色ID");
                return
            }
            if (channelName == "" || channelName == null) {
                layer.msg("请选择渠道");
                return;
            }

            var index = layer.load(1);
            $.ajax({
                url: api + "/snail/login/channel",
                type: "POST",
                data: {
                    role_id: roleId,
                    role_name: roleName,
                    channel: channelName,
                },
                xhrFields: { withCredentials: true },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    layer.msg(json.message);
                    if (json.code != 200) {
                        return;
                    }

                    // 清空填写的内容
                    $('.inp-role-name').val('');
                    $('.inp-role-id').val('');

                    // 刷新用户信息
                    obj.userInfo();

                    close();
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });

        // 短信登录
        $('.sms-login').click(function() {
            var account = $('.phone-inp').val();
            var code = $('input[name=sms_code]').val();

            var index = layer.load(1);
            $.ajax({
                url: api + '/snail/login/sms',
                type: "POST",
                xhrFields: { withCredentials: true },
                data: {
                    game_id: 39,
                    account: account,
                    sms_code: code
                },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    // 错误弹窗
                    if (json.code != 200) {
                        layer.msg(json.message);
                        return;
                    }

                    // 打开区服选择器
                    obj.serverInfo();

                    // 清空输入
                    $('.phone-inp').val('');
                    $('input[name=sms_code]').val('');
                },
                complete: function() {
                    layer.close(index)
                }
            })
        })

        // 点击切换账号按钮
        $('.tab-acco').click(function(event) {
            // 如果是b站的想切换帐号
            if (config.channel == 'bilibili') {
                $('.register-tab-title h2:nth-child(2)').addClass('select').siblings().removeClass('select');
                $('.register-tab-box .register-box:nth-child(2)').addClass('show').siblings().removeClass('show');
                obj.login();
                openA()
            } else if (config.uid && config.channel == 'qcplay') {
                obj.serverInfo()
            } else {
                $('.register-tab-title h2:nth-child(1)').addClass('select').siblings().removeClass('select');
                $('.register-tab-box .register-box:nth-child(1)').addClass('show').siblings().removeClass('show');
                obj.login();
                openA()
            }
        });

        // 注销
        $('.cancell-btn').click(function(event) {
            var index = layer.load(1)
            $.ajax({
                url: api + "/snail/logout",
                type: "POST",
                xhrFields: { withCredentials: true },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    layer.msg(json.message);
                    if (json.code == 200) {
                        obj.userInfo();
                        obj.login();
                        openA()
                    }
                },
                complete: function() {
                    layer.close(index)
                }
            });
            $('.popup').fadeOut();
        });

        // 确认
        $('.confirm-btn').click(function(event) {
            if (bindParams.rid == undefined) {
                layer.msg("请先选择信息");
                return false;
            }

            var index = layer.load(1);
            $.ajax({
                url: api + "/snail/qq-card/server/qcplay",
                type: "POST",
                xhrFields: { withCredentials: true },
                data: {
                    account: config.account,
                    ...bindParams
                },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    layer.msg(json.message);
                    if (json.code == 200) {
                        obj.userInfo()
                        $('.popup').fadeOut();
                    }
                },
                complete: function() {
                    layer.close(index)
                }
            });
        });

        // 验证码判断
        $('.obtain-verification').on('click', 'a', function(event) {
            var phone = $('.phone-inp');
            if (!phone.val()) {
                layer.msg("请输入手机号", { time: 2000 });
                phone.focus();
                return false;
            }

            var index = layer.load(1);
            $.ajax({
                url: api + '/snail/login/sms/send',
                type: "POST",
                xhrFields: { withCredentials: true },
                data: {
                    mobile: phone.val(),
                    channel: "login"
                },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    if (json.code != 200) {
                        layer.msg(json.message);
                        return;
                    } else {
                        // 倒计时
                        time();
                    }
                },
                complete: function() {
                    layer.close(index)
                }
            });
        });

        // 账号登录
        $('.register-btn').click(function(event) {
            var account = $('.inp-account').val();
            var password = $('.inp-password').val();
            if (account == '') {
                layer.msg("请输入您的账号", { time: 2000 });
                return false;
            }
            if (password == '') {
                layer.msg("请输入您的密码", { time: 2000 });
                return false;
            }

            var index = layer.load(1);
            $.ajax({
                url: api + "/snail/login/account",
                type: "POST",
                xhrFields: { withCredentials: true },
                data: {
                    account: account,
                    password: password,
                    game_id: 39
                },
                error: function() {
                    layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                },
                success: function(json) {
                    // 如果登录失败
                    if (json.code != 200) {
                        layer.msg(json.message);
                        return;
                    }

                    // 打开区服选择框
                    obj.serverInfo();

                    // 清空输入
                    $('.inp-account').val('');
                    $('.inp-password').val('');
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });

        // 60s倒计时
        var wait = 60;

        function time() {
            if (wait == 0) {
                $('.obtain-verification span a').remove();
                $('.obtain-verification span').html("<a>发送</a>");
                wait = 60;
            } else {
                $('.obtain-verification span a').remove();
                $('.obtain-verification span').html("<b>" + wait + "秒</b>");
                wait--;
                setTimeout(function() {
                    time()
                }, 1000)
            }
        }

        //  开启动画
        function openA() {
            setTimeout(function() {
                $('.popup_box').addClass('ani');
            }, 200);
        }

        // 关闭动画
        function close() {
            $('.popup').fadeOut().find('.popup_box').removeClass('ani');
        }

        // 点击弹窗背景关闭弹窗-通用
        $('.close-bg').click(function(event) {
            close();
        });
    },

    rewardMonitoring: function(life) {
        if (life < 80) $('.reward-list ul').addClass('state-1')
        if (life < 60) $('.reward-list ul').addClass('state-2')
        if (life < 40) $('.reward-list ul').addClass('state-3')
        if (life < 20) $('.reward-list ul').addClass('state-4')
        if (life <= 0) $('.reward-list ul').addClass('state-5')
    },

    effect: function(life, playnum, helpnum) {

        // 实时血量
        function lifeNew() {
            $('.life-number span').html(life);
            $('.life span').css({ 'width': '' + life + '%' })
            bloodVolume();
        }
        lifeNew()

        // 监控血量
        function bloodVolume() {
            if (life <= 59) { $('.role').addClass('injured') }
            if (life <= 0) { $('.role').addClass('end') }
        }

        // 奖励监控
        obj.rewardMonitoring(life)

        // 血量方法
        function lifeInfo(det) {
            life = life - det
            if (life < 0) {
                life = 0;
            }
            lifeNew();
        }

        function aniReset() {
            for (var i = 1; i < 5; i++) { $('.santa-claus .role').removeClass('roleAni-' + i + '') };
        }

        // 火箭筒攻击
        function armsX(x, number) {
            console.log(x);
            setTimeout(function() {
                $('.santa-claus').addClass('claus-' + x + ''); // 不同武器的丢置
                $('.arms').addClass('arms-Ani'); // 武器攻击动画
                setTimeout(function() {
                    $('.santa-claus .role').addClass('roleAni-' + x + ''); // 受伤动画
                    $('.lose-data').addClass('lose-' + x + ''); // 显示伤害文字
                    speak(x); // 随机的说话选择
                }, 1000);
                setTimeout(function() {
                    $('.santa-claus .role').removeClass('roleAni'); // 受伤动画
                    $('.santa-claus p').addClass('p-show'); // 显示血条
                    shock(); // 震动效果       
                    aniReset(); // 清除人物动画  
                    lifeInfo(number);
                    bloodVolume();
                    obj.rewardMonitoring(life);
                }, 1500);
                setTimeout(function() {
                    console.log(life)
                    if (life <= 0) {
                        $('.santa-claus p').removeClass('p-show');
                        $('.santa-box').addClass('eliminate')
                        setTimeout(function() {
                            // 打败圣诞老人弹窗
                            $('.success-popup').fadeIn();
                            openA()
                        }, 1500);
                    } else {
                        // 动画复位
                        animationReset();
                    }
                }, 3000);
            }, 5000);
        }

        // 随机的说话选择
        function speak(judgeX) {
            var randomxx = Math.floor(Math.random() * 2);
            var santaP = $('.santa-claus p');
            if (judgeX == 1) {
                randomxx == 0 ? santaP.html('小朋友不要乱丢果皮，踩到<br/>榴莲皮就不好了') : santaP.html('吃榴莲不吐榴莲皮，不吃<br/>榴莲被扔榴莲皮')
            }
            if (judgeX == 2) {
                randomxx == 0 ? santaP.html('哎哟喂！你的雪球里塞了<br/>铅块吗？') : santaP.html('我大意了啊，<br/>没有闪')
            }
            if (judgeX == 3) {
                randomxx == 0 ? santaP.html('龙珠都舍得丢，莫非<br/>你是赛亚星人？') : santaP.html('许愿直接找你好了！不就是<br/>被砸7次吗？')
            }
            if (judgeX == 4) {
                randomxx == 0 ? santaP.html('你这火箭筒的用法，着实<br/>惊艳到我了') : santaP.html('谢谢老板送出的<br/>火箭！')
            }
        }

        // 动画复位
        function animationReset() {
            $('.window-view').removeClass('new-frame'); // 显示伤害文字
            setTimeout(function() {
                // 显示伤害文字
                for (var i = 1; i < 5; i++) {
                    $('.santa-claus').removeClass('claus-' + i + '');
                    $('.santa-claus p').removeClass('p-show');
                    $('.lose-data').removeClass('lose-' + i + ''); // 伤害文字重置
                };
                $('.arms').removeClass('arms-Ani'); // 武器攻击动画重置
                $('.swiper-slide-active').removeClass('start'); // 开始时位置归位
            }, 4000);
        }

        // 微信-震动效果
        function shock() {
            if (navigator.vibrate) {
                navigator.vibrate(1000);
            } else if (navigator.webkitVibrate) {
                navigator.webkitVibrate(1000);
            }
        }

        // 关闭成功弹窗-复位动画
        $('.success-popup').on('click', '.close-bg', function(event) {
            animationReset();
        });

        // 转盘旋转停止的位置设置
        var reward = null;

        $('.playNumDraw').html(playnum);
        $('.playNumHelp').html(helpnum);
        var isture = 0;
        var clickfunc = function(data) {
            console.log
            switch (data) {
                case 1:
                    rotateFunc(13077, 0, '雪球*1');
                    armsX('2', '3');
                    break;
                case 2:
                    rotateFunc(11976, -45, '火箭炮*2');
                    armsX('4', '20');
                    break;
                case 3:
                    rotateFunc(11900, -90, '雪球*3');
                    armsX('2', '3');
                    break;
                case 4:
                    rotateFunc(14006, -135, '榴莲*4');
                    armsX('1', '6');
                    break;
                case 5:
                    rotateFunc(14001, -180, '雪球*5');
                    armsX('2', '3');
                    break;
                case 6:
                    rotateFunc(14004, -225, '龙珠*6');
                    armsX('3', '50');
                    break;
                case 7:
                    rotateFunc(15011, -270, '雪球*7');
                    armsX('2', '3');
                    break;
                case 8:
                    rotateFunc(11706, -315, '榴莲*8');
                    armsX('1', '6');
                    break;
            }
        }

        // 转盘旋转动画
        var rotateFunc = function(awards, angle, text) {
            $('.turntable-lighting').removeClass('spoonAni');
            $('.turntable-lighting').rotate({
                angle: 0,
                duration: 4000, //旋转时间
                animateTo: angle + 1440, //让它根据得出来的结果加上1440度旋转
                callback: function() {
                    // alert(text);
                    reward = text;
                    console.log(reward);
                    var index = layer.load(2, { shade: [0.1, '#fff'] });
                    $('.window-view').addClass('new-frame');

                    setTimeout(function() {
                        isture = false; // 标志为 执行完毕
                        layer.close(index);
                        $('.clouds dt').append('<img src="images/' + awards + '.png"></img>');
                        $('.clouds dd').html(text);
                    }, 100);
                }
            });
        };

        // 点击抽奖
        $('.luck-draw').off('click', '.draw-btn');
        $('.luck-draw').on('click', '.draw-btn', function() {
            $('.swiper-slide-active').addClass('start'); // 开始时位置归位
            if (isture) {
                return;
            } else {
                isture = true;
            }

            if (parseInt($('.playNumDraw').html()) <= 0) {
                // 没有攻击次数提示弹窗
                $('.share-popup-2').fadeIn();
                openA()

                $('.playNumDraw').html(0);
                isture = false;
            } else {
                var index = layer.load(1);
                $.ajax({
                    url: api + "/snail/christmas/lottery",
                    type: "POST",
                    xhrFields: { withCredentials: true },
                    error: function() {
                        layer.msg("很抱歉，当前服务器繁忙，请稍候再试");
                    },
                    success: function(json) {
                        if (json.code == 401) {
                            $('.tab-acco').trigger('click');
                            isture = false;
                            return;
                        }

                        if (json.code != 200) {
                            layer.msg(json.message);
                            return
                        }
                        $('.playNumDraw').html(json.data.count);
                        clickfunc(json.data.type);
                        obj.rewardMonitoring(100 - json.data.score)
                    },
                    complete: function() {
                        layer.close(index);
                    }
                })
            }
        });

        // 助力抽奖-提示弹窗
        $('.help-info').on('click', '.help-btn', function() {
            $('.share-popup-1').fadeIn();
            openA()
        });

        // 获取玩家信息邮寄礼物
        $('.fill-info-btn').click(function(event) {
            var name = $('.inp-name').val();
            var phone = $('.inp-phone').val();
            var address = $('.inp-address').val();

            if (name == "") {
                layer.msg("请输入角色名称");
                return
            }
            if (phone == "") {
                layer.msg("请输入联系电话");
                return
            }
            if (address == "") {
                layer.msg("请输入收货地址");
                return
            }
            layer.msg("数据上传中...");
            close();
        });

        // 贺卡
        $('.envelope-02, .envelope-03').click(function(event) {
            if (!$(this).hasClass('off')) {
                $('.greeting-cards-popup').fadeIn();
                openA()
            }
        });

        // 点击贺卡分享好友
        $('.greeting-cards a').click(function(event) {
            close();
            setTimeout(function() {
                $('.share-popup-1').fadeIn();
                openA();
            }, 200);
        });

        // 彩蛋1
        $('.envelope-01').click(function(event) {
            $('.order-popup-1').fadeIn();
            openA()
        });

        // 彩蛋2
        $('.envelope-04').click(function(event) {
            $('.order-popup-2').fadeIn();
            openA()
        });

        // 记录按钮
        $('.record-btn').click(function(event) {
            $('.record-popup').fadeIn();
            openA()
        });

        // 活动详情
        $('.details-btn').click(function(event) {
            $('.details-popup').fadeIn();
            openA()
        });

        // 信息变更
        $('.change-inf').click(function(event) {
            close();
            setTimeout(function() {
                $('.king-luck-popup').fadeIn();
                openA();
            }, 200);
        });

        // 点击查看活动奖励
        $('.reward-list').on('click', 'li', function(event) {
            if ($(this).find('img').hasClass('img-show')) {
                $('.reward-list li img').removeClass('img-show');
            } else {
                $(this).find('img').addClass('img-show').parent('li').siblings().find('img').removeClass('img-show');
            }
        });

        //  开启动画
        function openA() {
            setTimeout(function() {
                $('.popup_box').addClass('ani');
            }, 200);
        }

        // 关闭动画
        function close() {
            $('.popup').fadeOut().find('.popup_box').removeClass('ani');
        }

        // 点击弹窗背景关闭弹窗-通用
        $('.close-bg').click(function(event) {
            close();
        });

        // 音乐按钮
        $('.music').click(function(event) {
            var _this = $(this);
            if ($('#myMusic')[0].paused) {
                $('#myMusic')[0].play();
                _this.addClass('on');
            } else {
                $('#myMusic')[0].pause();
                _this.removeClass('on')
            }
        });


    },
    // 阻止默认页面弹起影响触摸位置
    preventInput: function() {
        $("input").blur(function() {
            setTimeout(function() {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }, 100);
        });
    },
}